"use strict";

exports.__esModule = true;
exports.isLoadingSelector = exports.hasErrorSelector = exports.getProductId = exports.consumptionDetailsSelector = exports.configSelector = void 0;

var _appConstants = require("../appConstants");

var configSelector = function configSelector(state, instanceId) {
  var _state$config, _state$config$data;

  var myWidget = (_state$config = state.config) == null ? void 0 : (_state$config$data = _state$config.data) == null ? void 0 : _state$config$data.widgets[_appConstants.pkgName];

  if (myWidget) {
    return myWidget[instanceId];
  }

  return null;
};

exports.configSelector = configSelector;

var isLoadingSelector = function isLoadingSelector(state) {
  var _state$pkgName;

  return (_state$pkgName = state[_appConstants.pkgName]) == null ? void 0 : _state$pkgName.isLoading;
};

exports.isLoadingSelector = isLoadingSelector;

var hasErrorSelector = function hasErrorSelector(state) {
  var _state$pkgName2;

  return (_state$pkgName2 = state[_appConstants.pkgName]) == null ? void 0 : _state$pkgName2.hasError;
};

exports.hasErrorSelector = hasErrorSelector;

var consumptionDetailsSelector = function consumptionDetailsSelector(state) {
  var _state$pkgName3;

  return (_state$pkgName3 = state[_appConstants.pkgName]) == null ? void 0 : _state$pkgName3.consumptionDetails;
};

exports.consumptionDetailsSelector = consumptionDetailsSelector;

var getProductId = function getProductId(state) {
  var _state$props, _state$props$topupLis;

  return (_state$props = state.props) == null ? void 0 : (_state$props$topupLis = _state$props.topupList) == null ? void 0 : _state$props$topupLis.phoneNumber;
};

exports.getProductId = getProductId;